import generatePicker, {
  RangePickerDateProps
} from 'antd/lib/date-picker/generatePicker'
import { Dayjs } from 'dayjs'
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs'

export type RangeDatePickerValue = RangePickerDateProps<Dayjs>['value']
export const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig)
